import { render, staticRenderFns } from "./chatRecordDialog.vue?vue&type=template&id=99b921b6&scoped=true"
import script from "./chatRecordDialog.vue?vue&type=script&lang=js"
export * from "./chatRecordDialog.vue?vue&type=script&lang=js"
import style0 from "./chatRecordDialog.vue?vue&type=style&index=0&id=99b921b6&lang=scss&scoped=true"
import style1 from "./chatRecordDialog.vue?vue&type=style&index=1&id=99b921b6&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b921b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/adam/Documents/Private_Repository/sjtx/backendAdmin/sjtx_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99b921b6')) {
      api.createRecord('99b921b6', component.options)
    } else {
      api.reload('99b921b6', component.options)
    }
    module.hot.accept("./chatRecordDialog.vue?vue&type=template&id=99b921b6&scoped=true", function () {
      api.rerender('99b921b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistics/ai/components/chatRecordDialog.vue"
export default component.exports